import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://twtysdlecawswoajkyrt.supabase.co' // ใส่ Project URL จาก Dashboard
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3dHlzZGxlY2F3c3dvYWpreXJ0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ3Mjg0MjYsImV4cCI6MjA4MDMwNDQyNn0.MRyP7WAzKQaatq6h9UprN1JTkkGCW9_JxCaG_8D4Wqg' // ใส่ Anon Key จาก Dashboard

export const supabase = createClient(supabaseUrl, supabaseKey)